import styled from 'styled-components';

export const ChipContainer = styled.div`
  display: flex;
  width: 100%;
  & > * {
    margin-right: 0.5rem;
  }
`;

export const ProfileChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 0.5rem;
  & > * {
    margin-right: 0.5rem;
  }
`;
